import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from './pages/login';
import PublicRoute from './routes/PublicRoute';
import ForgotPassword from './pages/forgot-password';
import AuthLayout from './layouts/AuthLayout';
import OTPVerifyPage from './pages/otp-verify';
import ResetPasswordPage from "./pages/reset-password";
import ProtectedRoute from "./routes/ProtectedRoute";
import AppLayout from "./layouts/AppLayout";
import AllCompanies from "./components/admin/all-companies/AllCompanies";
import AllPaymentsPage from "./pages/all-payments";
import GeneratedInvoicePage from "./pages/generated-invoice";
import AccountsPage from "./pages/accounts";
import MyProfilePage from "./pages/my-profile";
import ChangePasswordPage from "./pages/change-password";
import AddCompanyPage from "./pages/all-companies/add-company";
import OwnerDetailsPage from "./pages/owner-details";
import InvoiceDetailsPage from "./pages/generated-invoice/invoice-details";
import { pathNames } from "./constants/constants";
import CompanyDashboardPage from "./pages/all-companies/company-dashboard";
import PaymentsHistoryPage from "./pages/all-payments/payment-history";

function App() {
  return (
    <Router>
      <Routes>
        <Route
          element={
            <AuthLayout />
          }
        >
          <Route
            path="/login"
            element={
              <PublicRoute>
                <Login />
              </PublicRoute>
            }
          />

          <Route
            path="/forgot-password"
            element={
              <PublicRoute>
                <ForgotPassword />
              </PublicRoute>
            }
          />

          <Route
            path="/otp-verify"
            element={
              <PublicRoute>
                <OTPVerifyPage />
              </PublicRoute>
            }
          />

          <Route
            path="/reset-password"
            element={
              <PublicRoute>
                <ResetPasswordPage />
              </PublicRoute>
            }
          />
        </Route>
        <Route path={pathNames.ALL_COMPANIES} element={
          <ProtectedRoute>
            <AppLayout />
          </ProtectedRoute>
        }>
          <Route index element={<AllCompanies />} />
          <Route path={pathNames.ADD_COMPANY} element={<AddCompanyPage/>} />
          <Route path={pathNames.COMPANY_DASHBOARD_ID} element={<CompanyDashboardPage/>} />
          <Route path={pathNames.ALL_PAYMENTS} element={<AllPaymentsPage />} />
          <Route path={pathNames.PAYMENT_HISTORY_ID} element={<PaymentsHistoryPage />} />
          <Route path={pathNames.OWNER_DETAILS_ID} element={<OwnerDetailsPage />} />
          <Route path="generated-invoice" element={<GeneratedInvoicePage />} />
          <Route path="/generated-invoice/:id" element={<InvoiceDetailsPage />} />
          <Route path="accounts" element={<AccountsPage />} />
          <Route path="my-profile" element={<MyProfilePage />} />
          <Route path="change-password" element={<ChangePasswordPage />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
